import React from 'react';

import SingleLineTextPlaceholder from './single-line-text-placeholder';

const Placeholder = props => {
    return (
        <div className="custom-field">
            <div className="custom-field-inner">
                <div className="custom-field-head">
                    <SingleLineTextPlaceholder />
                </div>

                <div className="custom-field-value">
                    <SingleLineTextPlaceholder />
                </div>
            </div>
        </div>
    )
}

export default Placeholder;
